export const createEventTarget = () => {
    let eventTarget: EventTarget;
    try {
        eventTarget = new EventTarget();
    } catch {
        // if function EventTarget is not a constructor
        eventTarget = document.createDocumentFragment();
    }
    return eventTarget;
};
